import { EntityColumn } from '../types/grid';
import { ColumnOptionsBase, ServerSideColumnOption } from '../types/column-options';
import { Entity } from '@softline/core';
import { EntityColumnRef, GridRef, GroupColumnRef } from '../types/refs';

export interface ClientSideEntityColumnOptions<TRow extends object, TValue extends Entity> extends ColumnOptionsBase<TRow, TValue> {
  format: (value: TValue) => string;
  sortBy: (value: TValue) => number | string;
  rowGroup?: boolean;
}

export interface ServerSideEntityColumnOptions<TRow extends object, TValue extends Entity> extends ColumnOptionsBase<TRow, TValue>, ServerSideColumnOption {
  format: (value: TValue) => string;
  sortBy: (value: TValue) => number | string;
  serverSideSortField: string;
  rowGroup?: boolean;
}

export type EntityColumnOptions<TRow extends object, TValue extends Entity> = ClientSideEntityColumnOptions<TRow, TValue> | ServerSideEntityColumnOptions<TRow, TValue>;

export function entityColumn<TRow extends object, TValue extends Entity>(ref: GridRef<TRow> | GroupColumnRef<TRow>,
                                                                         options: EntityColumnOptions<TRow, TValue> | ServerSideEntityColumnOptions<TRow, TValue>,
                                                                         factory: (ref: EntityColumnRef<TValue>) => void): EntityColumn<TRow, TValue> {
  const entityColRef: EntityColumnRef<TValue> = new EntityColumnRef<TValue>(ref.formatter);
  factory(entityColRef);
  const entityCol: EntityColumn<TRow, TValue> = {
    ...options,
    type: 'entity',
    children: entityColRef.columns,
  };
  ref.createColumn(entityCol as EntityColumn<TRow, any>)
  return entityCol;
}
